export default class AuthorityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  hasRoleAdmin()
  {
    var user=this.ctx.$store.getters.user;
    if (user!=null)
    {
      return user.roles.includes("ROLE_ADMIN");
    }
    else
      return false;
  }

  hasRolePulverlagerListe()
  {
    var user=this.ctx.$store.getters.user;
    if (user!=null)
    {
      return user.roles.includes("ROLE_PULVERLAGERLISTE");
    }
    else
      return false;
  }

  hasVertragspreise()
  {
    var user=this.ctx.$store.getters.user;
    if (user!=null)
    {
      return user.vertragspreise;
    }
    else
      return false;
  }

}
